// extracted by mini-css-extract-plugin
module.exports = {"TotalSupplyLabel":"TotalSupply_TotalSupplyLabel__1wKZv","mintProgress":"TotalSupply_mintProgress__209Yy","mintProgressSupply":"TotalSupply_mintProgressSupply__1Mzog"};